import { PhxTooltipDirective } from 'phx-core';

import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';

export type ITooltipOntooltipTruncateDirection = 'horizontal' | 'vertical' | 'either';

@Directive({ selector: '[tooltipOnTruncate]' })
export class TooltipOnTruncateDirective {
  /** Which direction should be checked for truncation. */
  @Input() public tooltipTruncateDirection: ITooltipOntooltipTruncateDirection = 'horizontal';
  private el: HTMLElement;

  constructor(
    elRef: ElementRef,
    @Optional() private phxTooltip: PhxTooltipDirective,
  ) {
    this.el = elRef.nativeElement;
  }

  @HostListener('mouseenter', ['$event'])
  public onMouseenter(event: MouseEvent): void {
    event.stopImmediatePropagation();

    if (this.isEllipsisActive() && this.phxTooltip) this.phxTooltip.showTooltip();
  }

  @HostListener('mouseleave')
  public onMouseleave(): void {
    if (this.phxTooltip) this.phxTooltip.hideTooltip();
  }

  private isEllipsisActive(): boolean {
    const horizontalOverflow: boolean = ['horizontal', 'either'].includes(this.tooltipTruncateDirection) &&
      this.el.offsetWidth < this.el.scrollWidth;
    const verticalOverflow: boolean = ['vertical', 'either'].includes(this.tooltipTruncateDirection) &&
      this.el.offsetHeight < this.el.scrollHeight;
    return horizontalOverflow || verticalOverflow;
  }
}